import * as Yup from 'yup';

// const phoneRegExp = /^\+[1-9]\d{1,14}$/;

export const inspectionNominationSchema = (selectedAgent: string) => {
    return (
        Yup.object({
            companyType: Yup.string()
                .required('Company type is required'),
            companyName: Yup.string()
                .trim()
                .max(100, 'Company name must not exceed 100 characters')
                .required('Company name is required'),
            inspectionDate: Yup.date()
                .required('Inspection date is required'),
            location: Yup.string()
                .trim()
                .required('Location is required'),
            requestDate: Yup.date()
                .required('Request date is required'),
            market: Yup.string()
                .trim()
                .required('Market is required'),
            nominationType: Yup.string()
                .trim()
                .required('Type is required'),
            agentName: !selectedAgent ? Yup.string()
                .trim()
                .max(50, 'Agent name must not exceed 50 characters')
                .required('Agent name is required') : Yup.string().nullable(),
            agentOfficePhone: !selectedAgent
                ? Yup.string()
                    .trim()
                    .required('Agent office phone is required')
                : Yup.string().nullable(),
            agentMobilePhone: !selectedAgent 
                ? Yup.string()
                    .trim()
                    .required('Agent mobile phone is required')
                : Yup.string().nullable(),
            agentFax: Yup.string().nullable(),
            agentEmailAddress: !selectedAgent ? Yup.string()
                .trim()
                .email('Enter a valid email address')
                .required('Agent email address is required') : Yup.string().nullable(),
            nameOfVessel: Yup.string()
                .trim()
                .max(50, 'Name of vessel must not exceed 50 characters')
                .required('Name of vessel is required'),
            typeOfVessel: Yup.string()
                .trim()
                .required('Type of vessel is required'),
            ETAVessel: Yup.string()
                .trim()
                .nullable(),
            portOfBerth: Yup.string()
                .trim()
                .nullable(),
            countryOfInspection: Yup.string()
                .trim()
                .required('Country of inspection is required'),
            portOfInspection: Yup.string()
                .trim()
                .required('Port of inspection is required'),
            ETA: Yup.string()
                .trim()
                .required('ETA is required'),
            ETB: Yup.string()
                .trim()
                .nullable(),
            ETD: Yup.string()
                .trim()
                .required('ETD is required'),
            operation: Yup.string()
                .trim()
                .required('Operation is required'),
            cargo: Yup.string()
                .trim()
                .required('Cargo is required'),
            meansOfAccess: Yup.string()
                .trim()
                .required('Means of access is required'),
            inspectorName: Yup.string()
                .trim()
                .required('Inspector name is required'),
            groupLocation: Yup.string()
                .trim()
                .required('Group location is required'),
        }));
}
